// API Configuration
const API_CONFIG = {
  BASE_URL: "https://admin.sm6corp.com/api",
  SYSTEM_KEY: "SM6CORP251126",
};

/**
 * Submit contact form
 * @param {Object} formData - Contact form data { name, email, message }
 * @returns {Promise<Object>} Response data
 */
export const submitContactForm = async (formData) => {
  try {
    const response = await fetch(`${API_CONFIG.BASE_URL}/contact`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "System-Key": API_CONFIG.SYSTEM_KEY,
      },
      body: JSON.stringify({
        name: formData.name.trim(),
        email: formData.email.trim(),
        message: formData.message.trim(),
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to send message");
    }

    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error: error.message || "An error occurred. Please check your connection and try again.",
    };
  }
};

/**
 * Fetch website settings
 * @returns {Promise<Object>} Settings data
 */
export const fetchWebsiteSettings = async () => {
  try {
    const response = await fetch(`${API_CONFIG.BASE_URL}/website/settings`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "System-Key": API_CONFIG.SYSTEM_KEY,
      },
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch settings");
    }

    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error: error.message || "An error occurred while fetching settings.",
    };
  }
};

/**
 * Update website settings
 * @param {Object} settings - Settings data to update
 * @returns {Promise<Object>} Response data
 */
export const updateWebsiteSettings = async (settings) => {
  try {
    const response = await fetch(`${API_CONFIG.BASE_URL}/website/settings`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "System-Key": API_CONFIG.SYSTEM_KEY,
      },
      body: JSON.stringify(settings),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to update settings");
    }

    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error: error.message || "An error occurred while updating settings.",
    };
  }
};

export default API_CONFIG;

